module.exports = __webpack_public_path__ + "static/media/shopping-cart.acef374a.svg";